import OrganizationPreference from './Organization';

export default OrganizationPreference;
